import React from 'react';
import styles from './Enquiries.module.css';

const EnquiriesFilters = ({ activeFilter, onFilterChange, filterCounts }) => {
  const filters = [
    { id: 'all', label: 'All', count: filterCounts.all },
    { id: 'new', label: 'New', count: filterCounts.new },
    { id: 'conversation', label: 'In Conversation', count: filterCounts.conversation },
    { id: 'archived', label: 'Archived', count: filterCounts.archived },
  ];

  return (
    <div className={styles.filtersSection}>
      <div className={styles.filterPills}>
        {filters.map(filter => (
          <button
            key={filter.id}
            className={`${styles.filterPill} ${
              activeFilter === filter.id ? styles.filterPillActive : ''
            }`}
            onClick={() => onFilterChange(filter.id)}
            type="button"
            aria-pressed={activeFilter === filter.id}
            aria-label={`Filter by ${filter.label}, ${filter.count} items`}
          >
            <span>{filter.label}</span>
            <span className={styles.filterCount}>{filter.count}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default EnquiriesFilters;